import iconLinkedIn from '../../assets/img/icon-linkedin.webp';
import iconTwitter from '../../assets/img/icon-twitter.webp';
import iconGitHub from '../../assets/img/icon-github.webp';
import locationPin from '../../assets/img/locationPin.webp';
import IconBlack from "./IconBlack";
import NavbarFooter from "./NavbarFooter";
import EmailOptions from './EmailOptions';


const Footer = props => {
    return (
        <footer class='flex flex-wrap justify-evenly gap-5 lg:gap-10 max-w-5xl m-auto mt-32'>
            <NavbarFooter />
            <div class='text-left hero-content items-start'>
                <div class='max-w-2xl'>
                    <p class='mb-5'><span><img src={locationPin} class='h-4 inline mb-1 mr-1' alt='Location pin icon' /></span>San Jose, California</p>
                    <h1 class='mb-5  font-bold font-poppins'>
                        <span class='block text-md lg:text-xl'>Marco Eidinger,</span><span class='text-3xl lg:text-5xl subpixel-antialiased'>iOS<br />developer</span>
                    </h1>
                    <div class="dropdown dropdown-hover">
                        <a href='mailto:eidingermarco@gmail.com' target='_blank' rel="noreferrer" class="btn btn-outline btn-md">eidingermarco@gmail.com</a>
                        <EmailOptions />
                    </div>
                    <div class="mt-14 flex justify-between">
                        <IconBlack icon={iconLinkedIn} goTo='http://www.linkedin.com/pub/marco-eidinger/12/8a5/609/' ariaLabel='LinkedIn'>LinkedIn</IconBlack>
                        <IconBlack icon={iconTwitter} goTo='https://twitter.com/marcoeidinger' ariaLabel='Twitter'>Twitter</IconBlack>
                        <IconBlack icon={iconGitHub} goTo='https://github.com/MarcoEidinger' ariaLabel='GitHub'>GitHub</IconBlack>
                    </div>
                    <div class='mt-10 text-xs'>
                        <p>Design by Damian Demasi and icons from <a href='https://www.flaticon.com/' target='_blank' rel='noreferrer' class='link ' >Flaticon.</a></p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
